/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterZSmall = createReactComponent("letter-z-small", "IconLetterZSmall", [
  ["path", { d: "M10 8h4l-4 8h4", key: "svg-0" }]
]);

export { IconLetterZSmall as default };
//# sourceMappingURL=IconLetterZSmall.js.map
